import completedOrders from "./completedOrders"
export default completedOrders;
